export default __webpack_public_path__ + "static/media/22-HeartOfVenice.b9e67d09.jpeg";